import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { PureComponent, Children } from 'react';
import { TaskList as AkTaskList } from '@atlaskit/task-decision';
// Ignored via go/ees005
// eslint-disable-next-line @repo/internal/react/no-class-components
var TaskList = /*#__PURE__*/function (_PureComponent) {
  function TaskList() {
    _classCallCheck(this, TaskList);
    return _callSuper(this, TaskList, arguments);
  }
  _inherits(TaskList, _PureComponent);
  return _createClass(TaskList, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        children = _this$props.children,
        localId = _this$props.localId;
      if (Children.count(children) === 0) {
        return null;
      }
      return /*#__PURE__*/React.createElement(AkTaskList, {
        listId: localId
      }, children);
    }
  }]);
}(PureComponent);
export { TaskList as default };